var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.965,
    height: 56,
    viewBox: "0 0 57.965 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.771 5.116)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.733,42.973,7.5,41.268c5.089-3.837,5.538-17.761,12.566-21.317l-3.59-8.527C20.138,11,19.168,3.75,19.168,3.75h1.8s.521,4.263,4.488,4.263S29.939,3.75,29.939,3.75h1.8S30.765,11,34.427,11.424l-3.59,8.527c7.028,3.556,7.477,17.48,12.566,21.317l-5.385,1.705",
    transform: "translate(-7.5 -3.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.148,22.5,26.1,41.259H16.663l2.1-18.759",
    transform: "translate(-3.504 3.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.231,39.835,31.157,38.7,25.771,22.5",
    transform: "translate(-0.64 3.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.069,39.835,11.144,38.7l5.538-16.2",
    transform: "translate(-5.911 3.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.25,15.625a23.513,23.513,0,0,0,5.233.853h.153a25.712,25.712,0,0,0,5.385-.853",
    transform: "translate(-3.684 0.576)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 57.965,
    height: 55.067
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDress);
export default __webpack_public_path__ + "static/media/Dress.26f14d0c108f5fafc298d45a37432f9d.svg";
export { ForwardRef as ReactComponent };